import { NgModule } from '@angular/core';
import { SecureFrameComponent } from './secure-frame.component';

@NgModule({
  imports: [],
  declarations: [
    SecureFrameComponent
  ],
  exports: [
    SecureFrameComponent
  ]
})
export class SecureFrameModule {
}
